<template>
  <div class="widgets-galary">
    <div class="widgets-galary__item teacher-info">
      <div class="teacher-info__avatar">
        <div class="teacher-info__avatar-wrp">
          <span class="teacher-info__initials">{{ initialsFunc(userInfo.name) }}</span>
          <img
            class="teacher-info__img"
            :src="
              'https://teacher.open-college.ru/storage/avatars/' +
              userInfo.id +
              '.jpg'
            "
            onerror="this.onerror=null;this.style.display = 'none';"
          />
        </div>
        <p>{{ userInfo.name }}</p>
      </div>
      <ul class="teacher-info__property">
        <li>
          <b>Учёная степень</b>
          <span v-if="userProperty && userProperty.teacherInfo">{{
            userProperty.teacherInfo.stepen
              ? userProperty.teacherInfo.stepen
              : "Нет данных"
          }}</span>
          <span v-if="!userProperty">Нет данных</span>
        </li>
        <li>
          <b>Подразделение</b>
          <span v-if="userInfo.org">{{
            divisionTranslater(userInfo.org)
          }}</span>
          <span v-if="!userInfo.org">Нет данных</span>
        </li>
        <li>
          <b>Должность</b>
          <span v-if="userProperty && userProperty.teacherInfo">{{
            userProperty.teacherInfo.zvanie
              ? userProperty.teacherInfo.zvanie
              : "Нет данных"
          }}</span>
          <span v-if="!userProperty">Нет данных</span>
        </li>
      </ul>
    </div>
    <router-link
      class="widgets-galary__item"
      to="/journal"
      v-for="widget of widgets"
      :key="widget.name"
    >
      <span class="widgets-galary__item-curtain">Календарь</span>
      <sweet-calendar
        :arrow="true"
        :firstDayOfWeek="2"
        :offDays="[1, 7]"
        :eventCategories="eventCategories"
        :events="eventsInMonth"
      />
    </router-link>
    <div class="widgets-galary__item notify-info">
      <span class="widgets-galary__item-curtain">Информация</span>
      <div class="notify-info__message">
        <div class="cell">
          <span>Сообщения</span>
          <el-badge
            :hidden="!userProperty.countUnreadMsg"
            :value="userProperty.countUnreadMsg"
          >
            <router-link to="/messages"
              ><i class="fas fa-envelope"></i
            ></router-link>
          </el-badge>
        </div>
        <div class="cell">
          <span>Дисциплины</span>

          <el-badge
            :hidden="!userProperty.countDisciplines"
            :value="userProperty.countDisciplines"
          >
            <router-link to="/disciplines"
              ><i class="fas fa-book"></i
            ></router-link>
          </el-badge>
        </div>
        <div class="cell">
          <span>Работы</span>
          <el-badge
            :hidden="!userProperty.countUntestedWorks"
            :value="userProperty.countUntestedWorks"
          >
            <router-link to="/tresult"><i class="fas fa-poll"></i></router-link>
          </el-badge>
        </div>
        <div class="cell">
          <span>Инструкции и регламенты</span>
          <el-badge
            :hidden="!unviewedDocsCount"
            :value="unviewedDocsCount"
          >
            <router-link to="/docs"><i class="fas fa-question"></i></router-link>
          </el-badge>
        </div>
      </div>
    </div>
    <div class="widgets-galary__item event-info">
      <span class="widgets-galary__item-curtain">События на неделе</span>
      <div class="event-info__empty-message" v-if="!filtredEvents.length">
        <span>Нет событий</span>
      </div>
      <template v-else>
        <div class="event__table">
          <div class="table__row table__row--header">
            <span class="table__col">Дисциплина</span>
            <span class="table__col" v-if="!mobileMode">Начало</span>
            <span class="table__col">День</span>
            <span class="table__col">Дата</span>
          </div>
          <router-link
            v-for="(event, index) of filtredEvents"
            :key="index"
            class="table__row"
            to="/"
          >
            <span class="table__col">{{ event.discipline }}</span>
            <span class="table__col" v-if="!mobileMode">{{
              event.time_begin
            }}</span>
            <span class="table__col">{{ getNameDate(event.date) }}</span>
            <span>{{ setDate(event.date) }}</span>
          </router-link>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import sweetCalendar from "../components/sweetCalendar";
import journal from "./Journal";
import { mapMutations } from "vuex";

export default {
  name: "home",
  components: {
    journal,
    sweetCalendar,
  },
  data() {
    return {
      eventsInMonth: [],
      filtredEvents: [],
      eventCategories: [
        {
          id: 1,
          title: "Personal",
          textColor: "white",
          backgroundColor: "#0288D1",
        },
        {
          id: 2,
          title: "Company-wide",
          textColor: "white",
          backgroundColor: "#f56c6c",
        },
      ],
      widgets: [
        {
          name: "journal",
        },
      ],
      userInfo: this.$store.state.auth.user,
      userProperty: {},
      divisionTranslaterObject: {
        mip: "Московский институт психоанализа",
        mgok: "МГОК",
      },
    };
  },

  methods: {
    ...mapMutations(["setdashBordActive"]),
    divisionTranslater(value) {
      let el = this.divisionTranslaterObject;
      for (let key in el) {
        if (key === value) {
          return el[key];
        }
      }
    },
    async getEvents(date) {
      let shedule = "";
      let obj = { date_filter: date };
      await this.axios.get("/api/journal", { params: obj }).then((res) => {
        shedule = res.data.schedule;
      });
      return shedule;
    },
    setDate(date) {
      return this.$moment(date).locale("ru").format("DD.MM.YYYY");
    },
    initialsFunc(val) {
      let arr = val.split(/[\s,]+/);
      let a = arr[0][0];
      let b = arr[1][0] === "(" ? arr[2][0] : arr[1][0];
      return a + b;
    },
    getNameDate(value) {
      return this.$moment(value).locale("ru").format("dddd");
    },
    eventsFilter(array) {
      let date = new Date();
      let dayWeak = date.getDay();
      let firstDayOfWeek = +date - (dayWeak - 1) * 86400000;
      let lastDayOfWeek = +date + (7 - dayWeak + 1) * 86400000;
      let filtredArray = [];
      array.forEach((el) => {
        let elData = new Date(el.date);
        if (+elData <= lastDayOfWeek && +elData >= firstDayOfWeek) {
          filtredArray.push(el);
        }
      });
      return filtredArray;
    },
  },
  computed: {
    mobileMode() {
      return this.$store.state.mobileMode;
    },
    unviewedDocsCount() {
      return this.$store.getters["docs/unviewedCount"];
    },
  },

  async mounted() {
    const journalResponse = await this.axios.get("api/journal", { params: {
      date_filter: new Date()
    }});

    this.eventsInMonth = journalResponse.data.schedule.map(el => {
      el.categoryId = 1;
      el.currentdate = this.$moment(el.date).format("DD.MM.YYYY");
      return el;
    });

    this.filtredEvents = this.eventsFilter(journalResponse.data.schedule);

    const userPropertyResponse = await this.axios.get("api/properties");

    this.userProperty = userPropertyResponse.data;
  },
};
</script>

<style lang="scss">
.widgets-galary {
  margin: 0 auto;
  height: auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 30px;
  padding: 20px;
  width: 100%;
  #sweetCalendar .calendar {
    grid-template-rows: 50px 1fr;
  }
  &__item {
    padding: 40px 10px 10px 10px;
    position: relative;
    transition-property: transform, box-shadow;
    transition-duration: 0.3s;
    overflow: hidden;
    border-radius: 20px;
    max-width: 300px;
    width: 100%;
    height: 350px;
    @extend %box-shadow;
    &:hover {
      transform: scale(1.02);
      box-shadow: 0 5px 10px 5px #84b6d1;
    }
  }
  .event-info {
    max-width: 960px;
  }
  .widgets-galary__item-curtain {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
    height: 30px;
    color: $basic-white;
    background-color: $brand-clr-1;
  }
  .teacher-info {
    border-radius: 40px 0 40px 0;
    display: grid;
    grid-template-rows: repeat(auto-fill, max-content) auto;
    row-gap: 5px;
    align-items: center;
    padding: 20px;
  }
  .teacher-info__initials {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 25px;
  }
  .teacher-info__avatar-wrp {
    background-color: $placeholder-text-clr;
    margin-right: 10px;
    position: relative;
    border-radius: 50%;
    width: 80px;
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .teacher-info__avatar {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    p {
      font-size: 18px;
      font-weight: bold;
      width: min-content;
      word-wrap: break-all;
      margin: 0;
    }
  }
  .teacher-info__img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    justify-self: center;
    margin-right: 20px;
  }
  .teacher-info__property {
    align-self: flex-start;
    h3 {
      margin: 0;
    }
    li {
      font-size: 15px;
      display: grid;
      grid-template-columns: 1fr;
      grid-template-rows: max-content max-content;
      margin-bottom: 10px;
      row-gap: 5px;
    }
    b {
      color: $brand-clr-1;
    }
    span {
      color: $regular-text-clr;
    }
    span::first-letter {
      text-transform: uppercase;
    }
  }
  .notify-info {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .notify-info__message {
    display: grid;
    row-gap: 20px;
    column-gap: 20px;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(2, 1fr);
    justify-items: center;
    align-items: center;
    width: 100%;
    height: 100%;
    i {
      font-size: 50px;
      color: $secondary-text-clr;
    }
    span {
      display: block;
      margin-bottom: 15px;
      color: $brand-clr-1;
    }
    .el-badge {
      &:hover {
        i {
          color: $brand-clr-1;
        }
      }
    }
  }
  .cell {
    text-align: center;
  }
  .event-info__empty-message {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: $regular-text-clr;
  }
  .events-list__item {
    color: $regular-text-clr;
    height: max-content;
    transition-duration: 0.3s;
    transition-property: background-color;
    cursor: pointer;
    padding: 10px 0;
    justify-items: center;
    column-gap: 10px;
    display: grid;
    grid-template-columns: 1fr 1fr 80px 80px;
    border-bottom: 1px solid $base-border-clr;
    align-items: center;
    &:hover {
      background-color: $lighter-border-clr;
    }
  }
  .event__table {
    position: relative;
    overflow-y: auto;
    height: 100%;
  }
  .table__row {
    justify-items: center;
    align-items: center;
    transition-duration: 0.3s;
    transition-property: background-color;
    cursor: pointer;
    border-bottom: 1px solid $placeholder-text-clr;
    display: grid;
    grid-template-columns: 65% 10% 15% 10%;
    &:hover {
      background-color: $light-border-clr;
    }
  }
  .table__row--header {
    cursor: default;
    background-color: $basic-white;
    position: sticky;
    top: 0;
    &:hover {
      background-color: $basic-white;
    }
  }
  .table__col {
    padding: 10px;
  }
  .table__col:nth-child(1) {
    justify-self: flex-start;
  }
}
@media screen and (max-width: 1100px) {
  .widgets-galary {
    .calendar {
      max-width: 100%;
    }
    .widgets-galary {
      grid-template-columns: repeat(2, 1fr);
      padding: 0;
    }
    .row1-3 {
      max-width: 300px;
      width: 100%;
      grid-gap: 30px;
      grid-template-columns: 1fr;
    }
    .row2-3 {
      max-width: 300px;
      width: 100%;
      grid-template-columns: 1fr;
    }
    .event-header {
      grid-template-columns: repeat(2, 1fr);
    }
    .event-description {
      grid-template-columns: repeat(2, 1fr);
    }
  }
}
</style>
